export enum EMetricType {
    TOTAL,
    PER_SITE,
}

interface IDataPoint {
    x: number;
    y: number;
    uniqueUsers?: number;
}
type IDataPoints = Array<IDataPoint>;

interface IChartDataItems {
    name: string;
    color: string;
    data: IDataPoints;
    isSuggested?: boolean;
}

export type IChartData = Array<IChartDataItems>;
export type IChartDataAll = Record<EMetricType, IChartData>;
